import axios from "axios";

const apiBase = process.env.REACT_APP_API_BASE_URL || "";

const onboardingHeaders = (sessionToken) => ({
  "Content-Type": "application/json",
  "x-onboarding-session-token": sessionToken,
});

export const prefillApi = {
  async uploadDocument({ sessionId, sessionToken, file }) {
    const createResponse = await axios.post(
      `${apiBase}/onboarding/session/${sessionId}/prefill/documents`,
      {
        filename: file.name,
        content_type: file.type,
        byte_size: file.size,
      },
      { headers: onboardingHeaders(sessionToken) }
    );

    const { document_id, upload_url } = createResponse.data.data;

    // Upload bytes to S3 presigned URL
    await axios.put(upload_url, file, {
      headers: { 
        "Content-Type": file.type,
        "x-amz-server-side-encryption": "AES256"
      },
    });

    // Complete and enqueue
    const completeResponse = await axios.post(
      `${apiBase}/onboarding/session/${sessionId}/prefill/documents/${document_id}/complete`,
      {},
      { headers: onboardingHeaders(sessionToken) }
    );

    return completeResponse.data.data;
  },

  async getDocuments({ sessionId, sessionToken }) {
    const response = await axios.get(`${apiBase}/onboarding/session/${sessionId}/prefill/documents`, {
      headers: onboardingHeaders(sessionToken),
    });
    return response.data.data;
  },

  async getDraft({ sessionId, sessionToken }) {
    const response = await axios.get(`${apiBase}/onboarding/session/${sessionId}/prefill/draft`, {
      headers: onboardingHeaders(sessionToken),
    });
    return response.data.data;
  },

  async applyDraft({ sessionId, sessionToken, candidateIds, overrides = {} }) {
    const response = await axios.post(
      `${apiBase}/onboarding/session/${sessionId}/prefill/draft/apply`,
      { candidate_ids: candidateIds, overrides },
      { headers: onboardingHeaders(sessionToken) }
    );
    return response.data.data;
  },

  async recordFeedback({ sessionId, sessionToken, decisions }) {
    const response = await axios.post(
      `${apiBase}/onboarding/session/${sessionId}/prefill/feedback`,
      { decisions },
      { headers: onboardingHeaders(sessionToken) }
    );
    return response.data.data;
  },

  async deleteDocument({ sessionId, sessionToken, documentId }) {
    const response = await axios.delete(
      `${apiBase}/onboarding/session/${sessionId}/prefill/documents/${documentId}`,
      { headers: onboardingHeaders(sessionToken) }
    );
    return response.data.data;
  },

  async importJson({ sessionId, sessionToken, fields }) {
    const response = await axios.post(
      `${apiBase}/onboarding/session/${sessionId}/prefill/import`,
      {
        schema_version: "customer_onboarding_prefill.v1",
        fields,
      },
      { headers: onboardingHeaders(sessionToken) }
    );
    return response.data.data;
  },
};
